import { getDefaultStore } from "jotai"
import { pendingAudioByProfileIdAtom } from "./store"
import { updateSessionProfileId } from "@/lib/chunkDb"
import { silentError } from "@/shared/lib/silentError"

/** Move local pending audio from one profile id to another (after rename). */
export function remapPendingAudio(from: string, to: string): void {
    if (from === to) return
    const store = getDefaultStore()
    const prev = store.get(pendingAudioByProfileIdAtom)
    if (!prev[from]?.length) return
    const moved = prev[from] ?? []
    const next = { ...prev }
    next[to] = [...(next[to] ?? []), ...moved]
    delete next[from]
    store.set(pendingAudioByProfileIdAtom, next)

    for (const record of moved) {
        if (!record.sessionId) continue
        updateSessionProfileId(record.sessionId, to).then(undefined, (err) =>
            silentError("updateSessionProfileId", err),
        )
    }
}
